import React,{useEffect,useMemo,useState} from 'react';
import {useNavigate} from 'react-router-dom';
import API from '../utils/api';
import FaceCamera from '../components/FaceCamera';

export default function OwnerFace(){
  const nav=useNavigate();
  const[data,setData]=useState(null),[memberId,setMemberId]=useState(''),[file,setFile]=useState(null),[preview,setPreview]=useState(null),[saving,setSaving]=useState(false),[cameraOpen,setCameraOpen]=useState(false);

  const load=async()=>{
    try{
      const r=await API.get('/property-archive/me');
      setData(r.data);
      setMemberId(old=>old || (r.data.self_member?String(r.data.self_member.id):(r.data.members?.[0]?String(r.data.members[0].id):'')));
    }catch(e){alert(e.response?.data?.message||'读取失败')}
  };
  useEffect(()=>{load();},[]);

  const selectedMember=useMemo(()=>data?.members?.find(m=>String(m.id)===String(memberId))||null,[data,memberId]);
  const selectedAccess=useMemo(()=>data?.access_people?.find(a=>String(a.member_id)===String(memberId))||null,[data,memberId]);
  const selectedPending=useMemo(()=>data?.change_requests?.find(x=>x.change_type==='face_update'&&x.status==='pending'&&(String(x.member_id||'')===String(memberId)||String(x.target_id||'')===String(memberId)))||null,[data,memberId]);

  const pick=e=>{const f=e.target.files?.[0];if(f){if(preview)URL.revokeObjectURL(preview);setFile(f);setPreview(URL.createObjectURL(f));}};
  const submit=async()=>{
    if(!memberId)return alert('请先选择人员');
    if(!file)return alert('请先拍摄正脸照片');
    if(selectedPending)return alert('该人员已有待审核人脸申请，请等待物业处理');
    setSaving(true);
    try{
      const fd=new FormData();fd.append('member_id',memberId);fd.append('face_photo',file);
      const r=await API.post('/property-archive/me/face-request',fd,{headers:{'Content-Type':'multipart/form-data'}});
      alert(r.data.message);setFile(null);if(preview)URL.revokeObjectURL(preview);setPreview(null);await load();
    }catch(e){alert(e.response?.data?.message||'提交失败')}finally{setSaving(false)}
  };

  if(!data)return <div style={s.empty}>加载中...</div>;
  const state=faceState(selectedPending,selectedAccess);
  const allFaceRequests=(data.change_requests||[]).filter(x=>x.change_type==='face_update');
  const selectedHistory=allFaceRequests.filter(x=>String(x.member_id||x.target_id||'')===String(memberId)).slice(0,5);

  return <div style={s.page}>
    <header style={s.header}><button style={s.back} onClick={()=>nav('/')}>← 返回</button><div><div style={s.title}>🙂 门禁人脸</div><div style={s.sub}>{data.property.room_no}</div></div></header>
    <main style={s.body}>
      <div style={s.notice}>为保障门禁安全，人脸照片不会直接下发。提交后由物业审核，审核通过才会创建安居宝门禁同步任务。</div>

      <section style={s.card}>
        <label style={s.field}>选择人员
          <select style={s.input} value={memberId} onChange={e=>{setMemberId(e.target.value);setFile(null);if(preview)URL.revokeObjectURL(preview);setPreview(null)}}>
            {data.members.map(m=><option key={m.id} value={m.id}>{m.real_name} · {m.member_type}</option>)}
          </select>
        </label>
        {selectedPending && <div style={s.pendingTip}>⏳ {selectedMember?.real_name||'该人员'}已有待审核人脸申请，无需重复提交。</div>}
          <FaceCamera
            open={cameraOpen}
            onClose={()=>setCameraOpen(false)}
            onCapture={(f,url)=>{
              if(preview)URL.revokeObjectURL(preview);
              setFile(f);
              setPreview(url);
              setCameraOpen(false);
            }}
          />
          <div
            onClick={()=>{if(!selectedPending)setCameraOpen(true)}}
            style={{...s.photoBtn,opacity:selectedPending ? .55 : 1,padding:0,overflow:'hidden',background:'#fff',cursor:selectedPending?'not-allowed':'pointer'}}
          >
            <img
              src="/images/face-capture-guide.png"
              alt="人脸拍摄示例"
              style={{display:'block',width:'100%',borderRadius:12}}
            />
          </div>

        <img
          src="/images/face-photo-examples.png"
          alt="人脸拍摄正确与错误示例"
          style={{display:'block',width:'100%',margin:'12px 0',borderRadius:12}}
        />
        {preview?<><div style={s.photoCaption}>本次准备提交的照片</div><img src={preview} alt="预览" style={s.preview}/></>:(selectedMember?.face_photo?<><div style={s.photoCaption}>当前已审核人脸照片</div><img src={faceUrl(selectedMember.face_photo)} alt="当前人脸" style={s.preview}/></>:null)}
        <button style={{...s.save,opacity:(saving||selectedPending) ? .55 : 1}} disabled={saving||!!selectedPending} onClick={submit}>{saving?'提交中...':selectedPending?'等待物业审核':'提交物业审核'}</button>
      </section>

      <section style={s.card}>
        <h3 style={s.h3}>当前选择人员门禁状态</h3>
        <div style={s.personTitle}><b>{selectedMember?.real_name||'未选择人员'}</b><span style={{...s.badge,...badgeStyle(state.kind)}}>{state.label}</span></div>
        <div style={s.stateBox}>
          {selectedPending ? <>
            <div style={s.stateLine}>申请状态：物业审核中</div>
            <div style={s.muted}>提交时间：{dt(selectedPending.created_at)}</div>
          </> : selectedAccess ? <>
            <div style={s.stateLine}>门禁记录：{status(selectedAccess.status)}</div>
            {Number(selectedAccess.model_no)>0?<div style={s.muted}>安居宝编号：{selectedAccess.credence_id}（人员序号 {selectedAccess.model_no}）</div>:null}
            <div style={s.muted}>{selectedAccess.last_result||'暂无同步结果'}</div>
            {selectedAccess.updated_at?<div style={s.muted}>更新时间：{dt(selectedAccess.updated_at)}</div>:null}
          </> : <div style={s.none}>该人员尚未申请门禁人脸</div>}
        </div>
        <div style={s.explain}>这里只显示上方当前选择人员的状态，不再混入同一房屋其他家庭成员的同步结果。</div>
      </section>

      <section style={s.card}>
        <h3 style={s.h3}>{selectedMember?.real_name||'当前人员'} · 最近人脸申请</h3>
        {selectedHistory.length?selectedHistory.map(x=><div style={s.item} key={x.id}><div style={s.top}><b>{dt(x.created_at)}</b><span>{requestStatus(x.status)}</span></div>{x.review_note?<div style={s.muted}>物业备注：{x.review_note}</div>:null}</div>):<div style={s.emptySmall}>暂无申请记录</div>}
      </section>
    </main>
  </div>;
}

function faceState(pending,access){
  if(pending)return{kind:'pending',label:'待物业审核'};
  if(!access)return{kind:'none',label:'尚未申请'};
  // status 是门禁回执的权威状态。不要再扫描 last_result 文本，
  // 因为“成功2台，失败0台”包含“失败”两个字，会造成成功任务被误判失败。
  if(access.status==='registered')return{kind:'ok',label:'已启用'};
  if(access.status==='revoked')return{kind:'none',label:'已注销'};
  if(access.status==='failed')return{kind:'failed',label:'同步失败（未生效）'};
  if(access.status==='partial')return{kind:'failed',label:'部分设备失败'};
  if(access.status==='picked')return{kind:'pending',label:'同步中'};
  return{kind:'pending',label:'待同步'};
}
const status=(x)=>({registered:'已启用',revoked:'已注销',failed:'同步失败（未生效）',pending:'待同步',picked:'同步中',partial:'部分成功'})[x]||x||'未同步';
const faceUrl=name=>name?'/uploads/'+encodeURIComponent(String(name).split(/[\\/]/).pop()):'';
const requestStatus=x=>({pending:'待审核',approved:'已通过',rejected:'已驳回'})[x]||x||'-';
const badgeStyle=k=>k==='ok'?{background:'#f6ffed',color:'#389e0d'}:k==='failed'?{background:'#fff1f0',color:'#cf1322'}:k==='pending'?{background:'#fff7e6',color:'#d48806'}:{background:'#f5f5f5',color:'#777'};
const dt=v=>v?String(v).replace('T',' ').slice(0,19):'-';
const s={page:{minHeight:'100vh',background:'#f5f7fa'},header:{display:'flex',alignItems:'center',gap:12,background:'#1f5fae',color:'#fff',padding:15},back:{border:0,background:'transparent',color:'#fff',fontSize:15},title:{fontSize:21,fontWeight:800},sub:{fontSize:12,opacity:.85,marginTop:3},body:{maxWidth:680,margin:'0 auto',padding:14},notice:{background:'#fff7e6',color:'#8a6200',borderRadius:10,padding:13,fontSize:13,lineHeight:1.7,marginBottom:12},card:{background:'#fff',borderRadius:13,padding:15,marginBottom:12,boxShadow:'0 2px 8px rgba(0,0,0,.04)'},field:{display:'flex',flexDirection:'column',gap:7,fontSize:14},input:{border:'1px solid #ddd',borderRadius:9,padding:12,fontSize:15},pendingTip:{marginTop:10,background:'#fffbe6',color:'#ad6800',borderRadius:8,padding:10,fontSize:12},photoBtn:{display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center',gap:9,marginTop:12,textAlign:'center',minHeight:280,padding:14,border:'2px dashed #75b4cb',borderRadius:14,background:'#f5fcfd',color:'#087d7d',fontWeight:800,fontSize:16},preview:{display:'block',width:'100%',maxWidth:360,height:420,objectFit:'contain',margin:'8px auto 12px',borderRadius:12,background:'#f5f5f5'},photoCaption:{textAlign:'center',fontSize:12,color:'#78828c',marginTop:12},save:{width:'100%',border:0,borderRadius:9,padding:13,background:'#13a8a8',color:'#fff',fontWeight:800,fontSize:15},h3:{margin:'0 0 11px',fontSize:18},personTitle:{display:'flex',alignItems:'center',justifyContent:'space-between',gap:10,fontSize:17},badge:{fontSize:12,borderRadius:20,padding:'5px 10px',fontWeight:800},stateBox:{marginTop:12,border:'1px solid #edf0f3',background:'#fafcfe',borderRadius:10,padding:12},stateLine:{fontWeight:700,color:'#333'},muted:{fontSize:12,color:'#78828c',marginTop:7,lineHeight:1.55},none:{color:'#999',padding:'10px 0',textAlign:'center'},explain:{fontSize:11,color:'#999',marginTop:9,lineHeight:1.5},item:{border:'1px solid #edf0f3',borderRadius:9,padding:10,marginTop:8},top:{display:'flex',justifyContent:'space-between',gap:8},empty:{padding:28,textAlign:'center',color:'#999'},emptySmall:{padding:20,textAlign:'center',color:'#aaa'}};
